import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import followme from "../../assets/followme.jpg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Contact() {
  const form = useRef();
  const notify = () => toast("Your message has been sent!");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_r5tspbo",
        "template_yphrtpm",
        form.current,
        "oI6VDpQZDciv06xxl"
      )
      .then(
        (result) => {
          alert("message sent successfully...");
          console.log(result.text);
        },
        (error) => {
          alert(error.text);
        }
      );
  };

  return (
    <div className="contact">
      <h2 className="page-title text-4xl font-bold">Get in Touch</h2>
      <p className="page-subtitle">
        Got any work request? Hit me up! Whether you have a question or just
        want to say hi, I'll get back to you as fast as possible!
      </p>

      <div className="mx-auto">
        <img src={followme} alt="" className="picture" />
      </div>

      <div className="main-text">
        <form ref={form} onSubmit={sendEmail}>
          <input type="hidden" name="contact_number" />
          <label htmlFor="fname">Name</label>
          <input type="text" name="user_name" id="fname" required />
          <label htmlFor="email">Email</label>

          <input type="email" name="user_email" id="email" required />
          <label htmlFor="message">Message</label>
          <textarea name="message" rows="3" id="message" required />
          <button
            onClick={notify}
            className="send-btn"
            type="submit"
            value="Send"
          >
            Hit me!
          </button>
          <ToastContainer
            position="bottom-left"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </form>
      </div>
    </div>
  );
}
